
















import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseChip from "@/components/BaseChip";
import CheckAuthorities from "@/components/CheckAuthorities";
import FormatMoney from "@/components/FormatMoney";
import OptionItem from "../OptionItem";

@Component({ name: "OptionPrice", components: { OptionItem, BaseChip, FormatMoney, CheckAuthorities } })
export default class OptionPrice extends mixins(WithAuthUser) {
  @Prop({ required: true })
  public readonly postData!: ContentSet;

  public priceOneTime: number = 0;

  public priceRecurring: number = 0;

  public get isFree() {
    return this.priceOneTime === 0 && this.priceRecurring === 0;
  }

  public get requiredAuthorities() {
    const isAuthor = this.authUserStrict.id === this.postData.userId || false;
    return isAuthor
      ? ["updateMyContentPrice", "updateMyContentSubscriptionLevel"]
      : ["updateAnyContentPrice", "updateAnyContentSubscriptionLevel"];
  }

  public onClick() {
    emitter.emit(EVENTS.CONTENT_FEED_PRICE_SHOW);
  }

  public onPriceChange({
    recurringLevel,
    oneTimePackage,
  }: {
    recurringLevel: SubscriptionLevel | null;
    oneTimePackage: PaymentPackage | null;
  }) {
    this.priceOneTime = oneTimePackage?.amount ?? 0;
    this.priceRecurring = recurringLevel?.pricePackage?.amount ?? 0;
  }

  public created() {
    emitter.on<any>(EVENTS.CONTENT_FEED_PRICE_CHANGED, this.onPriceChange);
    this.$once("hook:beforeDestroy()", () => emitter.off<any>(EVENTS.CONTENT_FEED_PRICE_CHANGED, this.onPriceChange));
  }
}
